import Store from '@/store';

export function openSideBar() {
  Store.commit('openSideBar');
}

export function closeSideBar() {
  Store.commit('closeSideBar');
}

export function closeOnlySideBar() {
  Store.commit('closeOnlySideBar');
}

export function switchExpand() {
  Store.commit('switchExpand');
}

export function clear() {
  Store.commit('clear');
}

export function updateActivePath(path: string) {
  Store.commit('updateActivePath', path);
}

export function updateRecaptchaResponse(response: string) {
  Store.commit('updateRecaptchaResponse', response);
}
